import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "product-features-list__list" }
const _hoisted_2 = {
  key: 0,
  class: "product-features-list__label"
}
const _hoisted_3 = { class: "product-features-list__label" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, featureIndex) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "product-features-list__item",
        key: `${featureIndex}_feature`
      }, [
        (feature.headline && feature.values.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(feature.headline), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.values, (featureValue, featureValueIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `${featureValueIndex}_name`
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(featureValue.name), 1 /* TEXT */),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _createElementVNode("span", {
              class: "product-features-list__value",
              innerHTML: featureValue.value
            }, null, 8 /* PROPS */, _hoisted_4)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}